import * as z from 'zod/v4';
import { ENVIRONMENTS_NAMES, validationSchema } from '../../types';
import { userSchema } from '../users/users.schemas';
import { localizedStringSchema } from '../events/sections/event-shared-object.schema';
import { colorSchema } from '../events/sections/event-sections.schemas';

export const collectionSchema = z.object({
  id: z.uuid(),
  title: localizedStringSchema,
  displayTitleInGame: z.boolean(),
  bannerColor: colorSchema.nullable().optional(),
  backgroundColor: colorSchema.nullable().optional(),
  createdAt: z.coerce.date(),
  lastUpdatedAt: z.coerce.date(),
  eventsCount: z.number(),
  lastModifiedBy: userSchema.pick({ name: true, email: true, id: true }),
});

export const createCollectionBodySchema = z.object({
  title: localizedStringSchema,
  displayTitleInGame: z.boolean().default(false),
  bannerColor: colorSchema.nullable().optional(),
  backgroundColor: colorSchema.nullable().optional(),
});

export const createCollectionSchema = validationSchema({
  body: createCollectionBodySchema,
  response: {
    201: z.object({
      collection: collectionSchema.omit({ lastModifiedBy: true, eventsCount: true }),
    }),
    500: z.object({
      errorMessage: z.string(),
    }),
  },
});

export const updateCollectionSchema = validationSchema({
  params: z.object({
    id: z.uuid(),
  }),
  body: createCollectionBodySchema,
  response: {
    200: z.object({
      collection: collectionSchema.omit({ lastModifiedBy: true, eventsCount: true }),
    }),
    500: z.object({
      errorMessage: z.string(),
    }),
  },
});

export const getCollectionsSchema = validationSchema({
  querystring: z.object({
    search: z.string().optional(),
    excludeIds: z.array(z.uuid()).optional(),
    ids: z.array(z.uuid()).optional(),
    env: z.enum(ENVIRONMENTS_NAMES).optional(),
    page: z.coerce.number().optional(),
    pageSize: z.coerce.number().optional(),
  }),
  response: {
    200: z.object({
      collections: z.array(collectionSchema),
      total: z.number(),
      totalPages: z.number(),
    }),
    500: z.object({
      errorMessage: z.string(),
    }),
  },
});

export const deleteCollectionSchema = validationSchema({
  params: z.object({
    id: z.uuid(),
  }),
  response: {
    204: z.void(),
    500: z.object({
      errorMessage: z.string(),
    }),
  },
});

export const getCollectionSchema = validationSchema({
  params: z.object({
    id: z.uuid(),
  }),
  response: {
    200: z.object({
      collection: collectionSchema,
    }),
    404: z.object({
      errorMessage: z.string(),
    }),
    500: z.object({
      errorMessage: z.string(),
    }),
  },
});
